import axios from "axios";
import api from "./api";

// Use stored regional URL if available, otherwise fall back to env default
const storedBaseUrl = localStorage.getItem("regionalApiUrl");
axios.defaults.baseURL = storedBaseUrl || process.env.REACT_APP_BASE_URL;

// Enable credentials for HttpOnly cookie auth
axios.defaults.withCredentials = true;

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);

// Preserve the historical APIClient contract: callers (redux-saga flows via
// fakebackend_helper) expect the response BODY, not the full axios response.
const unwrap = (r) => (r && r.data !== undefined ? r.data : r);

// Route all APIClient traffic through the shared `api` instance so saga-driven
// calls get the same transparent 401→refresh→retry recovery, CSRF header, and
// timezone header as the rest of the app. Previously these went through the bare
// global `axios`, which had no refresh interceptor — a 401 there hard-failed as
// "Invalid credentials" with no session recovery. (The global `axios` instance
// and its interceptor above remain for pre-auth raw calls, e.g. identity_helper.)
class APIClient {
  /**
   * Fetches data from given url
   */
  get = (url, params) => {
    return api.get(url, params).then(unwrap);
  };

  /**
   * post given data to url
   */
  create = (url, data) => {
    return api.post(url, data).then(unwrap);
  };

  /**
   * Updates data
   */
  update = (url, data) => {
    return api.put(url, data).then(unwrap);
  };

  /**
   * Delete
   */
  delete = (url, config) => {
    return api.delete(url, { ...config }).then(unwrap);
  };
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, getLoggedinUser };
